import React from 'react';
import { AdminSidebarComponentProps } from '@website-editor/customComponents/JsonComponent.types';

import { LayoutAddComponentListItem } from '@website-editor/features/custom-page/components/LeftPanelLayouts/LayoutAddComponentListItem';
import { useEventCallback } from '@shared/utils/hooks/useEventCallback';
import { useGoToCreateView } from '@website-editor/customComponents/hooks/useJsonComponentNavigation';
import { ThingsToDoConfig } from './ThingsToDo.config';
import { INITIAL_DATA } from './ThingsToDoEdit';
import { ComponentType } from '@graphql/generated';
import { useEventInfo } from '@shared/utils/eventInfo';
import { useTranslation } from '@shared/core';
import { SimpleGrabHandle } from '@website-editor/components/SimpleGrabHandle';
import { Experiences } from '@withjoy/joykit/icons';
import { TextV2 } from '@withjoy/joykit';
import { useWebsiteEditorThingsToDoTelemetry } from '../DefaultThingsToDo/DefaultThingsToDo.telemetry';
import { ThingsToDo } from './ThingsToDo.types';

// Tip:
// This is the grab handle for your component in the sidebar
// while re-ordering components.
export const ThingsToDoGrabber = (props: AdminSidebarComponentProps) => {
  return (
    <SimpleGrabHandle
      title={props.componentData.containerContent.content.poi.title}
      icon={<Experiences size={32} />}
      {...props}
    ></SimpleGrabHandle>
  );
};

// Tip:
// This is the button that shows in the "Add Content" page
export const ThingsToDoAdd = (props: AdminSidebarComponentProps) => {
  const { t } = useTranslation('websiteEditor');
  const { title } = t('customPage', 'thingsToDo');
  const { goToCreateView } = useGoToCreateView();
  const eventInfo = useEventInfo();
  const eventCity = eventInfo?.eventInfo?.locationInfo?.city;
  const eventId = eventInfo?.eventInfo?.eventId;
  const telemetry = useWebsiteEditorThingsToDoTelemetry();
  const handleClick = useEventCallback(() => {
    telemetry.goToAddComponentClicked(props.pageSlug, 'ThingsToDo');
    const content: ThingsToDo = { ...INITIAL_DATA, location: { city: eventCity || 'N/A' } };
    goToCreateView({
      id: props.componentData.id,
      containerContent: {
        id: props.containerId,
        type: ThingsToDoConfig.componentType,
        content,
        eventId: eventId || '',
        schemaUrl: ThingsToDoConfig.schemaUrl,
      },
      type: ComponentType.jsonDataBlob,
      sortOrder: 0,
      jsonDataContainerId: props.containerId,
      __typename: 'JsonDataBlobComponent',
    });
  });
  return (
    <LayoutAddComponentListItem onClick={handleClick}>
      <Experiences size={48} />
      <TextV2
        typographyVariant="hed2"
        textAlign="left"
      >
        {title()}
      </TextV2>
    </LayoutAddComponentListItem>
  );
};
